module.exports = __webpack_public_path__ + "img/liolio-reward.55045997.svg";